import React, { useEffect, useState } from 'react';
import { Row } from 'antd';
import { IGetApiType } from '../../REST';
import { useRouterStore } from '../../hooks';
import { cleanMonthlyOrderStore, getMonthlyOrderById } from '../../middleware';
import { Catcher } from '../Catcher';
import { MonthlyOrderOrdersListEdit } from './Components/MonthlyOrderOrdersListEdit';
import { MonthlyOrderView } from './Components/MonthlyOrderView';
import Styles from '../styles/m_itemCardStyles.less';

export const MonthlyOrder: React.FC = () => {
    const idSpinners: IGetApiType[] = [
        'GET_MONTHLY_ORDER',
        'GET_MONTHLY_ORDER_AVAILABLE_ORDERS',
        'POST_MONTHLY_ORDER_APPROVE',
        'POST_MONTHLY_ORDER_CANCEL',
        'PATCH_MONTHLY_ORDER_PO_NUMBER',
        'POST_MONTHLY_ORDER_LINK_ORDER',
        'POST_MONTHLY_ORDER_MARK_AS_PAID',
        'POST_MONTHLY_ORDER_UNLINK_ORDER',
    ];
    const routerStore = useRouterStore();
    const [id, setId] = useState('');

    useEffect(() => {
        const { params } = routerStore.routerState;
        if (params.id) {
            setId(params.id);
        }
    });
    useEffect(() => {
        id && getMonthlyOrderById(id);
    }, [id]);

    useEffect(() => {
        return (): void => {
            cleanMonthlyOrderStore();
        };
    }, []);

    return (
        <Catcher>
            <div className={Styles.main}>
                <Row>
                    <MonthlyOrderView idSpinners={idSpinners} />
                    <MonthlyOrderOrdersListEdit idSpinners={idSpinners} />
                </Row>
            </div>
        </Catcher>
    );
};
